<template>
	<span v-if="!hideButton">

	<button :class="'button is-rounded ' + theme" v-on:click="click" :disabled="disabledComputed" v-if="modeButton=='normal'" >
	 	<div>
			<div>
			<span class="icon" v-if="icon">
				<i :class="'fas fa-' + icon"></i>			
			</span>
			<span v-if="label!=''" class="labelButton">
				{{label}} 
			</span>
			<span class="afterIcon"  v-if="afterIcon">
				&nbsp;&nbsp;<i :class="'fas fa-' + afterIcon"></i>			
			</span>
			</div>
	 		<div class="raccourci" v-if="raccourci">[{{raccourci}}]</div>
		 </div>
		 <s-arrow :id="id"  :label="label"/>
	</button> 
	<s-arrow :id="id"  :label="label"  :V="mode=='V'" v-if="modeButton!='normal'" />
	<div v-if="mode=='V'" class="modeV">
		
		<button  :class="'button is-rounded ' + theme" v-on:click="click" :disabled="disabledComputed" >
			<span class="icon" v-if="icon">
				<i :class="'fas fa-' + icon"></i>			
			</span>
		</button>
		
		<div v-if="label!=''" :class="disabledComputed ? 'labelButtonVDisabled' : 'labelButtonV'">
				{{label}} 
					
		</div>
		
	</div>	
		
	</span>
</template>
<style scoped>
	
	.modeV {
		display: inline-block;
		width: 100%;
		text-align: center;
		
		font-weight: bolder;
		margin-left: 0px;
		margin-right: 5px;
		vertical-align: top;
	}
	.modeV div {
		
		margin-top: -5px;
	}
	.raccourci {
		font-size: 10px;
		width: 3px;
		padding-right: 25px; 
	}
	
	.labelButton {
		font-weight: bolder;
		padding-top: 10px;
		font-size: 15px;
	}
	@media screen and (max-width: 420px) {  
		.labelButtonV {
			font-weight: bolder;
			padding-top: 10px;
			font-size: 11px;
			color: black;
		}
		.labelButtonVDisabled {
			
			padding-top: 10px;
			font-size: 11px;
			color: rgb(155, 155, 155)
		}
	}	
	@media screen and (min-width: 420px) {  
		.labelButtonV {
			font-weight: bolder;
			padding-top: 10px;
			font-size: 15px;
			color: black;
		}
		.labelButtonVDisabled {
			
			padding-top: 10px;
			font-size: 15px;
			color: rgb(155, 155, 155)
		}
	}
</style>
<script>
	export default {
		props: ["id","icon", "label","theme","afterIcon", "disabled","role", "enterKey","raccourci","owneronly", "mode"],
		methods: {
			click() {
				var id, byId;
				if (typeof(this.id)!="undefined") {
					id = this.id;
					byId = true;
				}
				else {
					id = this.label;
					byId = false;
				}
				
				this.$tuto(id, byId, this.$route.name, this.icon, (okGo)=>{
					
					if (okGo) {
						this.$emit("onclick");
					}
				});
			},
			keyEnter() {
				if (this.enterKey)
					this.$emit("onclick");
			}
		},
		
		computed: {
			modeButton: {
				get() {
					if (typeof(this.mode)=="undefined") {
						return "normal"
					}
					else
						return this.mode;
				}
			},
			hideButton: function() {
				var role = false;
			
				if (typeof(this.role) == "undefined") {
					role = false;
				}
				else {
					if (this.role == "owner") {
						role = false;
					}
					else if (this.role == "admin") {
						if (typeof(this.owneronly) != "undefined") {
							role = this.owneronly;
						}
						else
							role = false;
					}
					else
						role = true;
				}
				return role;
			},
			disabledComputed: function() {
				if (typeof(this.disabled) == "undefined")
					return false;
				else
					return this.disabled
			}
		}
	}
</script>